import { getDatePartsInAppTimezone } from '@/shared/utils/app-timezone';
export function appendPageable(q, page, size, sort) {
    q.set('page', String(page ?? 0));
    q.set('size', String(size ?? 10));
    if (sort) {
        q.set('sort', sort);
    }
}
export function appendCriteriaEquals(q, field, value) {
    if (value === undefined || value === null || value === '') {
        return;
    }
    q.set(`${field}.equals`, String(value));
}
export function appendCriteriaContains(q, field, value) {
    if (!value?.trim()) {
        return;
    }
    q.set(`${field}.contains`, value.trim());
}
export function appendCriteriaIn(q, field, values) {
    if (!values?.length) {
        return;
    }
    q.set(`${field}.in`, values.join(','));
}
/** Formats a date for Spring `LocalDate` criteria fields (YYYY-MM-DD in Kabul). */
export function toSpringLocalDateParam(d) {
    if (!d || Number.isNaN(d.getTime()))
        return undefined;
    const parts = getDatePartsInAppTimezone(d);
    const m = String(parts.month).padStart(2, '0');
    const day = String(parts.day).padStart(2, '0');
    return `${parts.year}-${m}-${day}`;
}
/** Formats a UTC instant for Spring range criteria (ISO 8601). */
export function toSpringDateTimeParam(d) {
    if (!d || Number.isNaN(d.getTime()))
        return undefined;
    return d.toISOString();
}
export function appendCriteriaGreaterThanOrEqual(q, field, value) {
    if (!value) {
        return;
    }
    q.set(`${field}.greaterThanOrEqual`, value);
}
export function appendCriteriaLessThanOrEqual(q, field, value) {
    if (!value) {
        return;
    }
    q.set(`${field}.lessThanOrEqual`, value);
}
/** Flat QSTAT search fields (Spring binds `QstatSearchCriteria` from query params). */
export function appendQstatSearchCriteria(q, criteria) {
    appendCriteriaGreaterThanOrEqual(q, 'startDate', criteria.startDate);
    appendCriteriaLessThanOrEqual(q, 'endDate', criteria.endDate);
    appendCriteriaIn(q, 'agents', criteria.agents);
    appendCriteriaIn(q, 'queues', criteria.queues);
    appendCriteriaContains(q, 'phoneNumber', criteria.phoneNumber);
    appendCriteriaIn(q, 'dispositions', criteria.dispositions);
}
const SPRING_TOTAL_COUNT_HEADERS = [
    'x-total-count',
    'X-Total-Count',
    'x-total-elements',
    'X-Total-Elements',
];
/**
 * Read Spring/JHipster pagination total from response headers.
 * Browsers only expose custom headers cross-origin when the API sends
 * `Access-Control-Expose-Headers: x-total-count` (or `*`).
 */
export function readSpringTotalCount(headers) {
    if (!headers) {
        return undefined;
    }
    for (const name of SPRING_TOTAL_COUNT_HEADERS) {
        let raw;
        if (typeof headers.get === 'function') {
            raw = headers.get(name);
            if (raw == null) {
                raw = headers.get(name.toLowerCase());
            }
        }
        else {
            const record = headers;
            raw = record[name] ?? record[name.toLowerCase()];
        }
        if (raw == null || raw === '') {
            continue;
        }
        const total = parseInt(String(raw), 10);
        if (Number.isFinite(total) && total >= 0) {
            return total;
        }
    }
    return undefined;
}
export function readPagedRows(data, headers) {
    if (Array.isArray(data)) {
        const headerTotal = readSpringTotalCount(headers);
        const total = headerTotal ?? data.length;
        return { rows: data, total };
    }
    const rows = data.content ?? [];
    const total = data.totalElements ?? readSpringTotalCount(headers) ?? rows.length;
    return { rows, total };
}
export function buildListQuery(page, size, sort, criteria) {
    const q = new URLSearchParams();
    appendPageable(q, page, size, sort);
    if (criteria) {
        for (const [field, value] of Object.entries(criteria)) {
            appendCriteriaEquals(q, field, value);
        }
    }
    const qs = q.toString();
    return qs ? `?${qs}` : '';
}
